import React from 'react'
import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate, useLocation, useNavigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import useAuth from '../../hooks/useAuth'
import {resolveRoleIndex, roles} from '../../roles'
import RTLProvider from './RTLProvider'
import ErrorBoundary from '../../components/ErrorBoundary'
const PrivateRoutes = () => {
  const LicensesPage = lazy(() => import('../pages/LicensesPage'))
  const UsersPage = lazy(() => import('../pages/UsersPage'))
  const EstablishementPage = lazy(() => import('../pages/EstablishementsPage'))
  const ClassesPage = lazy(() => import('../pages/ClassesPage'))
  const SubjectsPage = lazy(() => import('../pages/SubjectsPage'))
  const TypeExamsPage = lazy(() => import('../pages/TypeExams'))
  const TypeRemarquesPage = lazy(() => import('../pages/TypeRemarques'))
  const PaymentCategoriesPage = lazy(() => import('../pages/PaymentCategories'))
  const PaymentsPage = lazy(() => import('../pages/Payments'))
  const BillingPage = lazy(() => import('../pages/BillingPage/index'))
  const ExpendituresPage = lazy(() => import('../pages/Expenditures'))
  const RemarquesPage = lazy(() => import('../pages/Remarques'))
  const ExercicesPage = lazy(() => import('../pages/ExercicesPage'))
  const VideoGalleryPage = lazy(() => import('../pages/VideoGalleryPage'))
  const FileManagerPage = lazy(() => import('../pages/FileManagerPage/index'))
  const ExamsPage = lazy(() => import('../pages/ExamsPage'))
  const ProfilePage = lazy(() => import('../pages/ProfilePage'))
  const PromotionsPage = lazy(() => import('../pages/Promotions'))
  const StatistiquePage = lazy(() => import('../pages/Statistiques'))
  const InventoryManagementPage = lazy(() => import('../pages/InventoryManagementPage'))
  const InventoryTypePage = lazy(() => import('../pages/InventoryTypePage'))
  const InventoryStatisticsPage = lazy(() => import('../pages/InventoryStatisticsPage'))
  const EmailManagementPage = lazy(() => import('../pages/EmailManagement'))
  const GamingPanelPage = lazy(() => import('../pages/GamingPanel'))
  const PayrollPage = lazy(() => import('../pages/Payroll'))
  const PayrollCategoriesPage = lazy(() => import('../pages/PayrollCategories'))
  const InfoCenterPage = lazy(() => import('../pages/InfoCenter'))
  const QuizLeaderboardPage = lazy(() => import('../pages/QuizLeaderboardPage'))
  const RankingBoardPage = lazy(() => import('../pages/RankingBoardPage'))
  const GradesPage = lazy(() => import('../pages/GradesPage'))
  const NationalExamsPage = lazy(() => import('../pages/NationalExamsPage/index'))
  const AdminDocumentsPage = lazy(() => import('../pages/AdminDocumentsPage/index'))
  const QcmPlayPage = lazy(() => import('../pages/QcmPlayPage/index'))

  const location = useLocation()
  const navigate = useNavigate()
  const {me} = useAuth()
  React.useEffect(() => {
    if (!me) {
      return
    }
    const roleIndex = resolveRoleIndex(me.role)
    if (roleIndex === null) {
      return
    }
    const userRoles = roles[roleIndex]
    if (!userRoles?.length) {
      return
    }

    const raw = location.pathname
    const path = raw.length > 1 && raw.endsWith('/') ? raw.replace(/\/+$/, '') : raw

    let authorized = userRoles.some(
      (prefix) => path === prefix || path.startsWith(`${prefix}/`)
    )

    // National exams & QCM play share the same audience as school exams (see roles + Aside).
    if (
      !authorized &&
      (path === '/national-exams' ||
        path.startsWith('/national-exams/') ||
        path.startsWith('/qcm/') ||
        path === '/qcm')
    ) {
      authorized = userRoles.includes('/national-exams') || userRoles.includes('/exams')
    }

    if (!authorized) {
      navigate(userRoles[0])
    }
  }, [location.pathname, me, navigate])
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          {/* Pages */}
          {/* Lazy Modules */}
          {/*<Route
          path='/licenses/*'
          element={
            <SuspensedView>
              <LicensesPage />
            </SuspensedView>
          }
        /> */}
          <Route
            path='/info-center'
            element={
              <SuspensedView>
                <InfoCenterPage />
              </SuspensedView>
            }
          />
          <Route
            path='/ranking-board'
            element={
              <SuspensedView>
                <RankingBoardPage />
              </SuspensedView>
            }
          />
          <Route
            path='/quiz-leaderboard/:competitionId'
            element={
              <SuspensedView>
                <QuizLeaderboardPage />
              </SuspensedView>
            }
          />
          <Route
            path='/quiz-leaderboard'
            element={
              <SuspensedView>
                <QuizLeaderboardPage />
              </SuspensedView>
            }
          />
          <Route
            path='/profile'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />

          <Route
            path='/users/:id/edit'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='/users/*'
            element={
              <SuspensedView>
                <UsersPage />
              </SuspensedView>
            }
          />
          <Route
            path='/kids'
            element={
              <SuspensedView>
                <UsersPage />
              </SuspensedView>
            }
          />
          <Route
            path='/kids/:id/edit'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='/inventory/*'
            element={
              <SuspensedView>
                <InventoryManagementPage />
              </SuspensedView>
            }
          />
          <Route
            path='/inventory-types/*'
            element={
              <SuspensedView>
                <InventoryTypePage />
              </SuspensedView>
            }
          />
          <Route
            path='/inventory-statistics'
            element={
              <SuspensedView>
                <InventoryStatisticsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/games'
            element={
              <SuspensedView>
                <GamingPanelPage />
              </SuspensedView>
            }
          />
          <Route
            path='/file-manager'
            element={
              <SuspensedView>
                <FileManagerPage />
              </SuspensedView>
            }
          />
          <Route
            path='/email-management/*'
            element={
              <SuspensedView>
                <EmailManagementPage />
              </SuspensedView>
            }
          />
          <Route
            path='/establishements/*'
            element={
              <SuspensedView>
                <EstablishementPage />
              </SuspensedView>
            }
          />
          <Route
            path='/classes/*'
            element={
              <SuspensedView>
                <ClassesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/subjects/*'
            element={
              <SuspensedView>
                <SubjectsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/type-exams/*'
            element={
              <SuspensedView>
                <TypeExamsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/type-remarques/*'
            element={
              <SuspensedView>
                <TypeRemarquesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/payment-categories/*'
            element={
              <SuspensedView>
                <PaymentCategoriesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/payments/*'
            element={
              <SuspensedView>
                <PaymentsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/billing/*'
            element={
              <SuspensedView>
                <BillingPage />
              </SuspensedView>
            }
          />
          <Route
            path='/payroll/*'
            element={
              <SuspensedView>
                <PayrollPage />
              </SuspensedView>
            }
          />
          <Route
            path='/payroll-categories/*'
            element={
              <SuspensedView>
                <PayrollCategoriesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/expenditures/*'
            element={
              <SuspensedView>
                <ExpendituresPage />
              </SuspensedView>
            }
          />
          <Route
            path='/remarques/*'
            element={
              <SuspensedView>
                <RemarquesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/exams/*'
            element={
              <SuspensedView>
                <ExamsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/exercices/*'
            element={
              <SuspensedView>
                <ExercicesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/video-gallery/*'
            element={
              <SuspensedView>
                <VideoGalleryPage />
              </SuspensedView>
            }
          />
          <Route
            path='/grades/*'
            element={
              <SuspensedView>
                <GradesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/national-exams/*'
            element={
              <SuspensedView>
                <NationalExamsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/admin-documents/*'
            element={
              <SuspensedView>
                <AdminDocumentsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/qcm/:id'
            element={
              <SuspensedView>
                <QcmPlayPage />
              </SuspensedView>
            }
          />
          <Route
            path='/promotions/*'
            element={
              <SuspensedView>
                <PromotionsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/statistiques/*'
            element={
              <SuspensedView>
                <StatistiquePage />
              </SuspensedView>
            }
          />
          {/* Page Not Found */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}

const SuspensedView: FC<SuspensedViewProps> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}
interface SuspensedViewProps {
  children: React.ReactNode
}
export {PrivateRoutes}
